import { render, staticRenderFns } from "./IdentifyUser.vue?vue&type=template&id=7e2af8ae"
import script from "./IdentifyUser.vue?vue&type=script&lang=ts"
export * from "./IdentifyUser.vue?vue&type=script&lang=ts"
import style0 from "./IdentifyUser.vue?vue&type=style&index=0&id=7e2af8ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports